import type { FC } from 'react';

import { DeliveryInfoTemplate } from '@/modules/perseo-billing/containers/payment-complete/components/purchase-detail/deliveries';
import type { TPickupDelivery } from '@/modules/perseo-billing/interfaces/src/bff-web/billing';
import type { IconTypes } from '@/modules/perseo-billing/ui/react/src/components/beta';
import { Typography } from '@/modules/perseo-billing/ui/react/src/components/beta';
import { getDay, getMonth } from '@/modules/perseo-billing/utils';

const formatDeliveryDate = (delivery: TPickupDelivery): string => {
  const { deliveryDateString } = delivery || {};
  const day = getDay({
    dateString: deliveryDateString,
    responseFormat: 'numeric'
  });
  const month = getMonth({
    dateString: deliveryDateString,
    responseFormat: 'short'
  });

  return `${day} de ${month}`;
};

type deliveryPickUpInfoProps = {
  delivery: TPickupDelivery;
  deliveryIcon: IconTypes;
};

export const DeliveryPickUpInfo: FC<deliveryPickUpInfoProps> = ({
  delivery,
  deliveryIcon
}) => {
  const {
    proxyPickup: isThirdCollect,
    recipientFullName: deliveryPersonName,
    pickupStoreName
  } = delivery;

  const deliveryDate = formatDeliveryDate(delivery);

  const subject = isThirdCollect ? deliveryPersonName : 'Yo';

  const verb = isThirdCollect
    ? 'retirará mi producto.'
    : 'retiraré mi producto.';

  const additionalInfo = (
    <div className="co-flex co-flex-col co-gap-4px co-px-16px">
      <Typography size="body2" weight="semibold" noWrap>
        {`${subject} `}
        <span className="co-font-normal">{verb}</span>
      </Typography>
    </div>
  );

  return (
    <DeliveryInfoTemplate
      deliveryIcon={deliveryIcon}
      title={'Retiro en tienda'}
      additionalInfo={additionalInfo}
    >
      {pickupStoreName ? (
        <Typography size="body2" weight="medium" leading="16px">
          {pickupStoreName}
        </Typography>
      ) : null}
      <Typography
        size="h4"
        weight="semibold"
        className="co-text-[#485760]"
        leading="24px"
      >
        {deliveryDate}
      </Typography>
    </DeliveryInfoTemplate>
  );
};

DeliveryPickUpInfo.displayName = 'DeliveryPickUpInfo';

export default DeliveryPickUpInfo;
